import { isOneOf } from './isOneOf';

const ServerErrors = ['An internal server error occurred.'];

// Normally we log server errors only when we receive non-success response codes, but we've seen issues
// with receiving responses with 200 codes with errors in the body.
export function isServerError(message: string | undefined): boolean {
    return isOneOf(ServerErrors, message);
}
